import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { ROUTE_LANDING, ROUTE_ABOUT, ROUTE_ADVERTISE, ROUTE_TERMS, ROUTE_PRIVACY } from 'routes';

import {
  StyledPageWrap,
  StyledNav,
  StyledNavLinks,
  StyledHero,
  StyledHeroBadge,
  StyledHeroTitle,
  StyledHeroDesc,
  StyledBtnPrimary,
  StyledHeroSub,
  StyledDivider,
  StyledSectionLabel,
  StyledWhySection,
  StyledWhyTitle,
  StyledWhyGrid,
  StyledWhyCard,
  StyledCardIcon,
  StyledFormatsSection,
  StyledFormatsInner,
  StyledFormatsLabel,
  StyledFormatsTitle,
  StyledFormatsDesc,
  StyledFormatsGrid,
  StyledFormatCard,
  StyledAudienceSection,
  StyledAudienceTitle,
  StyledAudienceDesc,
  StyledTopicsWrap,
  StyledTopicTag,
  StyledCtaSection,
  StyledCtaInner,
  StyledCtaMark,
  StyledCtaTitle,
  StyledCtaDesc,
  StyledCtaEmail,
  StyledFooter,
  StyledFooterLeft,
  StyledFooterMark,
  StyledFooterMarkSecondary,
  StyledFooterCopy,
  StyledFooterLinks,
  StyledLogoDark,
} from './styled';

const TOPICS = [
  'Arts',
  'Sports',
  'Entertainment',
  'Photography',
  'Technology',
  'Food & Beverages',
  'Music',
  'Dance',
  'Performing Arts',
  'Business',
  'Publishing',
  'Writing',
  'Design & Fashion',
  'Science',
  'Games',
  'Lifestyle',
  'Films',
  'Health & Beauty',
  'Nature & Climate',
  'Travel',
  'Finance',
  'Government',
  'International Affairs',
  'Education',
];

const ArrowIcon: FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
  </svg>
);

const UsersIcon: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
    />
  </svg>
);

const ShieldIcon: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z"
    />
  </svg>
);

const ChartIcon: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3m0 0 .5 1.5m-.5-1.5h-9.5m0 0-.5 1.5m.75-9 3-3 2.148 2.148A12.061 12.061 0 0 1 16.5 7.605"
    />
  </svg>
);

const Advertise: FC = () => (
  <StyledPageWrap>
    {/* NAV */}
    <StyledNav>
      <Link to={ROUTE_LANDING}>
        <StyledLogoDark />
      </Link>
      <StyledNavLinks>
        <Link to={ROUTE_LANDING}>Home</Link>
        <Link to={ROUTE_ABOUT}>About</Link>
        <Link to={ROUTE_ADVERTISE} className="active">
          Advertise
        </Link>
      </StyledNavLinks>
    </StyledNav>

    {/* HERO */}
    <StyledHero>
      <StyledHeroBadge>Advertising &amp; Partnerships</StyledHeroBadge>
      <StyledHeroTitle>Advertise with guide:human</StyledHeroTitle>
      <StyledHeroDesc>
        Promote your brand, products, and services to a thoughtful, engaged audience across one of the web&apos;s most
        trusted social curation platforms. Reach real people who value quality over noise.
      </StyledHeroDesc>
      <StyledBtnPrimary href="mailto:hello@guidehuman.co">
        Get in touch
        <ArrowIcon />
      </StyledBtnPrimary>
      <StyledHeroSub>
        A <strong>GUIDE HUMAN</strong> platform
      </StyledHeroSub>
    </StyledHero>

    <StyledDivider />

    {/* WHY */}
    <StyledWhySection>
      <StyledSectionLabel>Why guide:human</StyledSectionLabel>
      <StyledWhyTitle>A better environment for your brand</StyledWhyTitle>
      <StyledWhyGrid>
        <StyledWhyCard>
          <StyledCardIcon>
            <UsersIcon />
          </StyledCardIcon>
          <h3>Engaged, quality audience</h3>
          <p>
            Our community is made up of curious, intentional people who actively curate and share meaningful content —
            not passive scrollers.
          </p>
        </StyledWhyCard>
        <StyledWhyCard>
          <StyledCardIcon>
            <ShieldIcon />
          </StyledCardIcon>
          <h3>Brand-safe environment</h3>
          <p>
            guide:human is built on trust and authenticity. Your brand appears alongside quality, human-curated content
            — never clickbait or misinformation.
          </p>
        </StyledWhyCard>
        <StyledWhyCard>
          <StyledCardIcon>
            <ChartIcon />
          </StyledCardIcon>
          <h3>Multi-topic reach</h3>
          <p>
            Reach audiences across dozens of interest areas — from arts, food, and travel to technology, finance, and
            lifestyle.
          </p>
        </StyledWhyCard>
      </StyledWhyGrid>
    </StyledWhySection>

    {/* FORMATS */}
    <StyledFormatsSection>
      <StyledFormatsInner>
        <StyledFormatsLabel>Advertising on g:h</StyledFormatsLabel>
        <StyledFormatsTitle>Placement options</StyledFormatsTitle>
        <StyledFormatsDesc>
          We offer flexible advertising placements designed to integrate naturally with the guide:human experience.
          Promote your goods and services to the right audience, at the right time.
        </StyledFormatsDesc>
        <StyledFormatsGrid>
          <StyledFormatCard>
            <h3>Sponsored Collections</h3>
            <p>
              Feature your brand within curated topic collections. Your content appears alongside high-quality, relevant
              picks chosen by our community of guides.
            </p>
          </StyledFormatCard>
          <StyledFormatCard>
            <h3>Display Advertising</h3>
            <p>
              Premium advertising space across the guide:human platform — web and mobile — with placements that respect
              the user experience.
            </p>
          </StyledFormatCard>
          <StyledFormatCard>
            <h3>Promoted Picks</h3>
            <p>
              Put your content in front of interested audiences as a promoted pick within relevant topic feeds and
              discovery surfaces.
            </p>
          </StyledFormatCard>
          <StyledFormatCard>
            <h3>Brand Partnerships</h3>
            <p>
              Custom campaigns and co-branded experiences. Work with the g:h team to create something that resonates
              with our community.
            </p>
          </StyledFormatCard>
        </StyledFormatsGrid>
      </StyledFormatsInner>
    </StyledFormatsSection>

    {/* AUDIENCE */}
    <StyledAudienceSection>
      <StyledSectionLabel>Audience &amp; Topics</StyledSectionLabel>
      <StyledAudienceTitle>Reach people who care</StyledAudienceTitle>
      <StyledAudienceDesc>
        guide:human users engage deeply across a wide range of interests. Promote your goods and services to audiences
        who are actively seeking and sharing content they value.
      </StyledAudienceDesc>
      <StyledTopicsWrap>
        {TOPICS.map((topic) => (
          <StyledTopicTag key={topic}>{topic}</StyledTopicTag>
        ))}
      </StyledTopicsWrap>
    </StyledAudienceSection>

    {/* CTA */}
    <StyledCtaSection>
      <StyledCtaInner>
        <StyledCtaMark>g:h</StyledCtaMark>
        <StyledCtaTitle>Let&apos;s work together</StyledCtaTitle>
        <StyledCtaDesc>
          Whether you&apos;re a brand, agency, or creator — we&apos;d love to hear from you. Reach our team to learn
          more about advertising opportunities and how guide:human can promote your goods and services to our growing
          community.
        </StyledCtaDesc>
        <StyledBtnPrimary href="mailto:hello@guidehuman.co">Contact our advertising team</StyledBtnPrimary>
        <StyledCtaEmail>
          Or email us directly at <a href="mailto:hello@guidehuman.co">hello@guidehuman.co</a>
        </StyledCtaEmail>
      </StyledCtaInner>
    </StyledCtaSection>

    {/* FOOTER */}
    <StyledFooter>
      <StyledFooterLeft>
        <StyledFooterMark>guide:human</StyledFooterMark>
        <StyledFooterMarkSecondary>g:h</StyledFooterMarkSecondary>
        <StyledFooterCopy>&copy; {new Date().getFullYear()} Guide Human Inc. All rights reserved.</StyledFooterCopy>
      </StyledFooterLeft>
      <StyledFooterLinks>
        <Link to={ROUTE_PRIVACY}>Privacy</Link>
        <Link to={ROUTE_TERMS}>Terms</Link>
        <a href="mailto:hello@guidehuman.co">Contact</a>
      </StyledFooterLinks>
    </StyledFooter>
  </StyledPageWrap>
);

export default Advertise;
